export enum REDEEM_URLS {
  REDEEMS = '/redeems',
  REDEEM_BY_ID = '/redeems/:id',
  REDEEMS_CSV = '/redeems/csv',
  REDEEM_EVENT = '/campaign/:code/redeem/events',
  REDEEM_REWARD_EVENT = '/rewards/:code/redeem/events',
  REDEEM_REWARD = '/rewards/:code/redeem',
  REDEEM_REWARDS = '/redeems/rewards',
  REDEEM_REWARDS_BY_ID = '/redeems/rewards/:id',
  REDEEM_REWARDS_CSV = '/redeems/rewards/csv',
}
